import clsx from 'clsx';
import React from 'react';

const StatusIcons = ({ children }) => {
  return (
    <div
      className={clsx(
        'tw-flex tw-items-center tw-justify-center tw-flex-col',
        'tw-max-w-[60px] tw-w-full',
        'tw-ml-[10px]'
      )}
    >
      {children}
    </div>
  );
};

export default StatusIcons;
